import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import Paragraph from './layout/Paragraph';
import Hero from './layout/hero/Hero';
import notFoundiamge from './img/notfound@2x.png'

const notFoundContent = {
  header: "Page not found",
  heading: "Wait, what am I seeing?",
  paragraph: "It seems like the page you have tried to visit no longer exists. \nWe all have no idea.🤷‍♀️ I hope it wasn't something you loved the most.",
  featuredImage: {
    backgroundImage: `url(${notFoundiamge})`,
  }
}


class NotFound extends Component {
  render () {
    return(
      <div>
        {/*Meta data*/}
        <Helmet>
         <meta charSet="utf-8"/>
         <title>404 ✴︎ Not found</title>
       </Helmet>
        <Navigation />
        <Hero
          style={notFoundContent.featuredImage}
          firstPage/>

        <Paragraph
          titleText={notFoundContent.header}
          heading={notFoundContent.heading}
          paragraph={notFoundContent.paragraph}
          extra={<div className="call-to-action"> <Link className="link link-convert" to="/" alt="Go to home" > <span>Go to Home</span> </Link> </div>}
          />



        <Footer />
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.js